import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { getOrderedRecipientsArray } from 'app/domains/esigning/utils';
import { RecipientItem } from '../../../RecipientItem';
import { RecipientModal } from '../../../RecipientModal';
import { RecipientsAccordion } from '../../../RecipientsAccordion';
import { RecipientActions } from '../RecipientActions';
import { RecipientSigningOrder } from '../RecipientSigningOrder';
export function OrderedSigningRecipients() {
    const { signerRecipients } = useEsigningRecipients();
    const { groupMessage } = useEsigningSettings();
    const [showAddPartyModal, setShowAddPartyModal] = useState(false);
    const assignedSignerRecipients = signerRecipients.filter(({ order }) => order !== undefined);
    const unassignedSignerRecipients = signerRecipients.filter(({ order }) => order === undefined);
    const showModal = () => setShowAddPartyModal(true);
    const hideModal = () => setShowAddPartyModal(false);
    if (unassignedSignerRecipients.length === 0 && assignedSignerRecipients.length === 0) {
        return null;
    }
    const orderEntries = getOrderedRecipientsArray(assignedSignerRecipients);
    const unassignedLabel = t({
        message: 'Unassigned parties',
        comment: 'Label for signing parties without order',
    });
    const getAssignedLabel = (order) => {
        const orderNumber = order + 1;
        return t({
            message: `Signing order ${orderNumber}`,
            comment: 'Label for signing parties with order selected',
        });
    };
    const addButton = (<Button data-id="add-signing-party-button" size="xs" appearance="secondary" onClick={showModal}>
      <Trans comment="Add signing party button label">Add party</Trans>
    </Button>);
    return (<Fragment>
      {showAddPartyModal && <RecipientModal onClose={hideModal}/>}
      {unassignedSignerRecipients.length > 0 && (<RecipientsAccordion hideTooManyItems title={unassignedLabel} endElement={addButton}>
          {unassignedSignerRecipients.map((recipient) => (<RecipientItem key={recipient.id} recipient={recipient} groupMessage={groupMessage} endElement={<Fragment>
                  <RecipientSigningOrder recipientId={recipient.id} order={recipient.order}/>
                  <RecipientActions recipient={recipient}/>
                </Fragment>}/>))}
        </RecipientsAccordion>)}
      {orderEntries.map(([order, orderedRecipients]) => (<RecipientsAccordion hideTooManyItems key={order} title={getAssignedLabel(+order)} endElement={addButton}>
          {orderedRecipients.map((recipient) => (<RecipientItem key={recipient.id} recipient={recipient} groupMessage={groupMessage} endElement={<Fragment>
                  <RecipientSigningOrder recipientId={recipient.id} order={recipient.order}/>
                  <RecipientActions recipient={recipient}/>
                </Fragment>}/>))}
        </RecipientsAccordion>))}
    </Fragment>);
}
